/* eslint-disable lingui/no-unlocalized-strings */
import { API_URL } from '@/constants/app';
import { getReadableMsg } from '@/constants/error';
import { clientJWT } from '@/utils/cookies';
import ky from 'ky';

export const request = ky.create({
  prefixUrl: API_URL.href,
  hooks: {
    beforeRequest: [
      (req, opt) => {
        const jwt = clientJWT();
        if (jwt) {
          req.headers.set('Authorization', jwt);
        }
      },
    ],
    beforeError: [
      async (error) => {
        const { response } = error;
        const json = await response.json<{
          error?: string;
          message?: string;
          statusCode?: number;
        }>();
        const __msg = getReadableMsg(json.message);

        return { ...error, json, __msg };
      },
    ],
  },
});
